import useSWR from "swr";

import { type DocumentSummary } from "../types";
import { simpleFetcher } from "../fetcher";

const url = "/api/v2/documents";

export function useDocuments() {
  return useSWR<DocumentSummary[], Error>(url, simpleFetcher);
}
